export default __webpack_public_path__ + "static/media/oi.e71f5338.svg";